import moment from 'moment-timezone';
import { Settings } from '@/services/settings.service';

moment.tz.setDefault(Settings.getTimezone());
